import { Dispatch } from "redux";
import { ApiConfig } from '../../../../config';
import { createRequestActionTypes } from "../../../../utils/request-actions-helpers/createRequestActionTypes";
import { createRequestThunk, RequestThunkParameters } from "../../../../utils/request-actions-helpers/createRequestThunk";
import { AppStateWithData } from "../../../AppStateWithData";
import { UpdateTaskAdditionalData } from "../tasksTypes";

export const deleteTaskActionTypes = createRequestActionTypes('DELETE_TASK')

export interface DeleteTaskAdditionalData {
    taskId: string,
    checklistUid: string
}

export const deleteTask = (config: ApiConfig) => (taskId: string, checklistUid: string) =>
    async (dispatch: Dispatch, getState: () => AppStateWithData) => {
        const thunkParams: RequestThunkParameters<any, never, DeleteTaskAdditionalData> = {
            method: 'DELETE',
            requestActionTypes: deleteTaskActionTypes,
            url: `${config.API_URL}/tasks?taskId=${encodeURIComponent(taskId)}`,
            processResultBeforeDispatch: (data) => {
                if(!!config.updateItem) {
                    config.updateItem('')
                }
    
                return data
            },
            actionAdditionalData: {
                checklistUid,
                taskId
            }
        }

        dispatch<any>(createRequestThunk(thunkParams))
    }